module.exports = __webpack_public_path__ + "static/media/IMG_1725.683e2fc4.JPG";